import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightBulbOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9 1.5C6.105 1.5 3.75 3.855 3.75 6.75C3.75 8.535 4.6425 10.1025 6 11.055V12.75C6 13.1625 6.3375 13.5 6.75 13.5H11.25C11.6625 13.5 12 13.1625 12 12.75V11.055C13.3575 10.1025 14.25 8.535 14.25 6.75C14.25 3.855 11.895 1.5 9 1.5ZM6.75 15.75C6.75 16.1625 7.0875 16.5 7.5 16.5H10.5C10.9125 16.5 11.25 16.1625 11.25 15.75V15H6.75V15.75ZM10.5 10.275L11.1375 9.825C12.15 9.12 12.75 7.9725 12.75 6.75C12.75 4.68 11.07 3 9 3C6.93 3 5.25 4.68 5.25 6.75C5.25 7.9725 5.85 9.12 6.8625 9.825L7.5 10.275V12H10.5V10.275Z",
		fill: "currentColor"
	})
});
export default SvgLightBulbOutline;
